import { Dialog } from '@/components/UI/Dialog'
import { IconExternalLink } from '@tabler/icons-react'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  onClose: () => void
  /** storybookで確認する際に、スクロール可にするためのフラグ。raundで利用する場合にはtrue */
  scrollLock?: boolean
  ilustMaps?: { caption: string; url: string | null }[] | null
  /** ダイアログのタイトル（管理画面の mapCaption を渡す。未指定時は翻訳キーのデフォルト値を使用） */
  title?: string | null
}

/**
 * `Raund-Replace / Screen UI / SPOT-PDF-MAP`のダイアログコンポーネント
 *
 * /spots のPDFマップを選択したときに表示される
 */
export const DialogIlustmap = memo(({ onClose, scrollLock = false, ilustMaps, title }: Props) => {
  const { t } = useTranslation()

  return (
    <Dialog selectorState={true} showCloseButton={false} lockScroll={scrollLock} closeAction={onClose}>
      <h1 className="text-black text-center text-[16px] font-bold leading-[24px]">
        {title || t('spot_detail.ilustmap.title', 'イラストマップ')}
      </h1>

      {ilustMaps && ilustMaps.length > 0 && (
        <ul className="mt-[25px] flex flex-col items-center">
          {ilustMaps.map((map, i) => (
            <li key={`${map.caption}-${i}`} className="mb-[16px] last:mb-0">
              {map.url ? (
                <a
                  href={map.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center gap-[8px] text-black"
                >
                  <span className="text-[14px] leading-[1.4]">{map.caption}</span>
                  <IconExternalLink size={14} stroke={2} aria-hidden="true" />
                </a>
              ) : (
                <p className="text-center text-[14px] leading-[1.4] text-black">{map.caption}</p>
              )}
            </li>
          ))}
        </ul>
      )}

      <div className="mt-[20px] flex justify-center">
        <button
          type="button"
          onClick={onClose}
          className="bg-[#eee] text-[#757575] text-[15px] font-bold rounded-[32px] h-[48px] w-[123px]"
        >
          {t('common.close', '閉じる')}
        </button>
      </div>
    </Dialog>
  )
})
